import clone from 'lodash/clone';
import {convertEditorStateToHtml, convertHtmlToEditorState} from '../../../../helpers/formik';
import {initialData} from './initialData';

export const Normalizer = {
  fetch: data => {
    let CompanySizeID = null;
    let Content = null;
    let Title = null;

    if (data.fields && data.options) {
      CompanySizeID =
        data.fields.CompanySizeID && data.options.CompanySizeID
          ? data.options.CompanySizeID.find(
              t => t.value === data.fields.CompanySizeID
            )
          : null;

      Content = convertHtmlToEditorState(data.fields.Content || '');
      Title = data.fields.Title || 'Investment Strategy';
    }

    return {
      ...initialData,
      fields: {
        ...initialData.fields,
        ...data.fields,
        CompanySizeID,
        Content,
        Title,
      },
      options: {
        ...initialData.options,
        ...data.options,
      },
      init: true,
    };
  },

  send: values => {
    const result = clone(values);
    Object.keys(result).forEach(f => {
      if (!result[f]) {
        delete result[f];
      } else if (['CompanySizeID'].includes(f)) {
        result[f] = result[f].value;
      } else if ('Content' === f) {
        result[f] = convertEditorStateToHtml(result[f]);
      }
    });

    return result;
  },
};
